import { Container, Spinner, SpinnerProps } from '@chakra-ui/react';

const defaultSpinnerProps: SpinnerProps = {
  thickness: '4px',
  speed: '0.5s',
  color: 'black',
  m: 100,
  size: 'xl',
};

type TruefileSpinnerSpinnerProps = {
  spinnerProps?: SpinnerProps
  hideSpinner?: boolean
  optionalSpinnerProps?: SpinnerProps
};

export default function TruefileSpinner({ spinnerProps = defaultSpinnerProps, optionalSpinnerProps, hideSpinner = false }: TruefileSpinnerSpinnerProps): React.ReactElement {
  return (
    <Container centerContent>
      <Spinner
        {...spinnerProps}
        {...optionalSpinnerProps}
        hidden={hideSpinner}
      />
    </Container>
  );
}
